import api from "../api";

export default {
    show(event) {
        return api.get(`/discovery/events/${event}`)
    }
}